export function warning(message: string) {
  console.warn(message, 'background: gold; font-size: 20px')
}
